import { setupClients } from '@internetworkexpert/js-common';

const env = process.env.REACT_APP_ENV || 'development';
const {
  API,
  BUSINESS,
  CONTENT,
  CONTENT_BACKOFFICE,
  STATISTICS,
  SUBSCRIPTIONS,
  UAA,
  BUSINESS_PYTHON,
  BUSINESS_PYTHON_ANONYMOUS,
  REPORTING,
  TEAMS_API,
  TEAMS_API_V2,
  RECOMMENDATION_API,
} = setupClients(env);

export {
  API,
  BUSINESS,
  CONTENT,
  CONTENT_BACKOFFICE,
  STATISTICS,
  SUBSCRIPTIONS,
  UAA,
  BUSINESS_PYTHON,
  BUSINESS_PYTHON_ANONYMOUS,
  REPORTING,
  TEAMS_API,
  TEAMS_API_V2,
  RECOMMENDATION_API,
};
